/* eslint-disable prefer-const */
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter, Inject, LOCALE_ID, NgZone, Renderer2, SimpleChanges, AfterViewInit, OnChanges } from '@angular/core';
import { StyleClassModule } from 'primeng/styleclass';
import { OmniSearchResponse, Client, PagedResults, ListClientResponse, TENANTSINTERFACE, STAGE_MASTER_MODEL, } from '@fitness-force/models';
// import { OmniSearchService } from 'libs/api/src/lib/omni-search.service';
import { BehaviorSubject, Subject, debounceTime, } from 'rxjs';
import { ChipModule } from 'primeng/chip';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { AvatarModule } from 'primeng/avatar';
import { AutoCompleteModule } from 'primeng/autocomplete';
import {  TranslateModule, TranslateService, } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { COMPANY_INFO, TENANTS_INFO, } from 'apps/ff-frontend/src/app/state/app.state';
import { ClientService, OmniSearchService } from '@fitness-force/api';
import { ElasticProviderName } from '@fitness-force/enum';
import { CommmonPipeModule } from '@fitness-force/pipes/common-pipes'
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { AppErrors } from '@fitness-force/errors';
import { ShortNamePipe } from '@fitness-force/pipes/short-name'

@Component({
  selector: 'mini-search',
  templateUrl: './mini-search.component.html',
  styleUrls: ['./mini-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    StyleClassModule,
    FormsModule,
    InputTextModule,
    AvatarModule,
    ChipModule,
    DialogModule,
    AutoCompleteModule,
    CommmonPipeModule,
    ShortNamePipe,
    TranslateModule,
    ScrollPanelModule
  ]
})
export class MiniSearchComponent implements OnInit, AfterViewInit,OnChanges {
  @Input('readonly') isReadonly = false;
  @Input('disabledctrl') isDisabled = false;
  @Input('id') clientIds: number[] = [];
  @Input('clientId') clientId = 0;
  @Input('showSelected') showSelected = true;
  @Input('showCreateClient') showCreateClient = true;
  @Output('clients') clients = new EventEmitter<any>();
  @Output('removedClient') removedClient = new EventEmitter<any>();
  @Output('createProspect') createProspect = new EventEmitter<any>();
  @Input('totalRecords') totalRecords = new BehaviorSubject<number>(0);
  @Input('selectedAllData') selectedAllData = new BehaviorSubject<boolean>(false);
  
  @Output() openclientsidebar : EventEmitter<{openclientsidebar: boolean, clientid:number}> = new EventEmitter();

  clientIds$ = new BehaviorSubject<number[]>([]);

  paramNMore = { N: 0 };
  paramNList = { N: 0 };
  members$: BehaviorSubject<Client[]> = new BehaviorSubject([] as Client[]);
  selectedClients$ = new BehaviorSubject<ListClientResponse[]>([]);
  showCreateProspectPopup$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  showAllMembers = false;
  searchText = '';
  inputValue = '';

  hideSearchDropdown = true;
  selectedClient$ = new BehaviorSubject<Client | null>(null);
  selectedClient = null;
  stage$ = new BehaviorSubject<STAGE_MASTER_MODEL | null>(null);
  prospectParams: Map<string, any> = new Map();
  tenantId = 0;
  allTenants: any[] = [];
  pageNumber = 0;
  pageSize = 10; // Adjust this value as per your requirement
  query='';
  private searchText$ = new Subject<string>();

  constructor(
    private omniSearchService: OmniSearchService,
    private clientService: ClientService,
    private store: Store,
    public translate: TranslateService,
    @Inject(LOCALE_ID) public locale: string,
    private renderer: Renderer2,
    private zone: NgZone
  ) {
    const client: Client[] = [];
    this.members$.next(client);
  }
  ngOnInit(): void {
    const companyInfoDetail$ = this.store.select(COMPANY_INFO);
    companyInfoDetail$.subscribe((responseData) => {
      this.translate.setDefaultLang(responseData?.selectedLang?.LANG_CODE);
      this.translate.use(responseData?.selectedLang?.LANG_CODE);
    });

    this.paramNMore = { N: this.selectedAllData.value ? this.totalRecords.value : this.clientIds.length - 3 };
    this.paramNList = { N: this.clientIds.length };

    this.store.select(TENANTS_INFO).subscribe((tenant: TENANTSINTERFACE) => {
      this.allTenants = tenant.accessed_tenant;
      if (tenant.selected_tenant.id > 0) {
        this.tenantId = tenant.selected_tenant.id;
      }
    });
    if (this.clientIds.length == 1) {
      this.clientId = this.clientIds[0];
      this.clientIds = [];
    }

    this.clientIds$.next(this.clientIds);

    if (this.clientIds.length > 0)
    {
      this.GetCLientsByClientIds();
    }

    if (this.clientId) this.GetCLientsByClientId();
  }

  ngAfterViewInit() {
    this.searchText$.pipe(debounceTime(300)).subscribe(obj => {
      this.searchClientInomniSearch(obj);
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isDisabled']) {
      console.log('isDisabled value:', this.isDisabled);
    }
  }
  
  GetCLientsByClientIds() {
    this.clientService
      .getProspects(this.getProspectParams, this.tenantId)
      .subscribe((obj1: PagedResults<ListClientResponse>) => {
        this.clientService
          .getClients(this.getClientsParams, this.tenantId)
          .subscribe((obj: PagedResults<ListClientResponse>) => {
            let lClient: any[] = [];
            if (obj && obj.items && obj.items.length) {
              lClient = lClient.concat(obj.items);
            }

            if (obj1 && obj1.items && obj1.items.length) {
              lClient = lClient.concat(obj1.items);
            }

            this.selectedClients$.next(lClient);
            this.clients.emit(lClient);
          });
      });
  }

  GetCLientsByClientId() {
    const request = {
      language: this.locale,
      query: this.clientId.toString(),
      providers: [
        {
          provider_name: ElasticProviderName.Clients,
          pagination: { page_number: 0, page_size: 10 },
        },
      ],
    };

    this.omniSearchService
      .Search(request)
      .subscribe((search: OmniSearchResponse) => {
        if (
          search &&
          search.searchResults &&
          search.searchResults.clients &&
          search.searchResults.clients.items &&
          search.searchResults.clients.items.length
        ) {
          if(this.clientId && this.clientId > 0)
          {
            const client = search.searchResults.clients.items.find(o => o.clt_id == this.clientId)!;
            this.selectedClient$.next(client);
            this.clients.emit(client);
          }
          else{
            const client = search.searchResults.clients.items[0]!;
            this.selectedClient$.next(client);
            this.clients.emit(client);
          }

        }
      });
  }

  search(search: string) {
    this.searchText$.next(search);
  }

  searchClients(event: any) {
    if(event && event.query && event.query.length >= 3)
    this.searchText$.next(event.query);
  }

  searchClientInomniSearch(value:string)
  {
    this.query = value;
    const request = {
      language: this.locale,
      query: value,
      providers: [
        {
          provider_name: ElasticProviderName.Clients,
          pagination: { page_number: 0, page_size: 10 },
        },
      ],
    };

    this.omniSearchService.Search(request).subscribe({
      next: (response: OmniSearchResponse) => {
        const client = response.searchResults.clients.items;
        this.members$.next(client);
      },
      error(msg) {
      },
    });
  }


  loadMoreClients(event:Event, pageNumber:number)
  {
    event.stopPropagation();
    this.addClass(event);
    this.pageNumber= pageNumber;
    this.pageSize = pageNumber+10;
    const request = {
      language: this.locale,
      query: this.query,
      providers: [{
        provider_name: ElasticProviderName.Clients,
        pagination: { page_number: pageNumber, page_size: this.pageSize }
      }]
    };

    this.omniSearchService.Search(request).subscribe({
      next: (response: OmniSearchResponse) => {
        const client = response.searchResults.clients.items;
        this.members$.next([...this.members$.getValue(),...client]);
        this.removeClass(event);
      },
      error: (error: AppErrors) => {
        this.removeClass(event);
      },
    });

  }


  setClient(event: any) {
    if (!this.showSelected) {
      this.clients.emit(event.value);
      this.clearClient();
      return;
    }
    this.selectedClient$.next(event.value);
    this.clientId = event.value.clt_id;
    this.members$.next([]);
    this.clients.emit(event.value);
  }

  clearClient() {
    this.selectedClient$.next(null);
    this.selectedClient = null;
    this.clientId = 0;
    this.removedClient.emit();
  }

  get getProspectParams(): Array<Map<string, any>> {
    this.prospectParams = new Map();
    this.prospectParams.set('home_club_tenant_id', {
      name: 'home_club_tenant_id',
      value: this.tenantId,
    });
    this.prospectParams.set('Prospect', {
      name: 'client_status',
      value: 'Prospect',
    });
    this.prospectParams.set('Client', {
      name: 'client_status',
      value: 'Client',
    });
    this.prospectParams.set('ClientNonMember', {
      name: 'client_status',
      value: 'ClientNonMember',
    });
    this.prospectParams.set('ExClient', {
      name: 'client_status',
      value: 'ExClient',
    });
    this.prospectParams.set('PageSize', {
      name: 'PageSize',
      value: 50,
    });
    this.prospectParams.set('PageNumber', {
      name: 'PageNumber',
      value: 1,
    });
    this.clientIds?.forEach((v: number, i: number) => {
      this.prospectParams.set(v.toString(), { name: 'client_id', value: v });
    });

    // this.prospectParams.set(this.clientId.toString(), { name: "client_id", value: this.clientId });

    return [...this.prospectParams.values()];
  }

  get getClientsParams(): Array<Map<string, any>> {
    this.prospectParams = new Map();
    this.prospectParams.set('home_club_tenant_id', {
      name: 'home_club_tenant_id',
      value: this.tenantId,
    });
    this.prospectParams.set('Client', {
      name: 'client_status',
      value: 'Client',
    });
    this.prospectParams.set('ClientNonMember', {
      name: 'client_status',
      value: 'ClientNonMember',
    });
    this.prospectParams.set('ExClient', {
      name: 'client_status',
      value: 'ExClient',
    });
    this.prospectParams.set('PageSize', {
      name: 'PageSize',
      value: 50,
    });
    this.prospectParams.set('PageNumber', {
      name: 'PageNumber',
      value: 1,
    });
    this.clientIds?.forEach((v: number, i: number) => {
      this.prospectParams.set(v.toString(), { name: 'client_id', value: v });
    });

    // this.prospectParams.set(this.clientId.toString(), { name: "client_id", value: this.clientId });

    return [...this.prospectParams.values()];
  }

  clientStatus(client: Client | null): string {
    if (client && (client.clt_status || (client as any)?.client_status))
      return this.clientService.getClientStatusHtml(
        (client.clt_status || (client as any)?.client_status).toString()
      );
    else return '';
  }

  get filteredClient(): Array<any> {
    if (!this.searchText) return this.selectedClients$.value;

    const search = String(this.searchText).toLowerCase();
    return this.selectedClients$.value.filter(
      (item) =>
        String(item.full_name).toLowerCase().indexOf(search) !== -1 ||
        item.id == parseInt(this.searchText)
    );
  }

  client2LetterName(name: string): string {
    if (name) {
      const nameArray: string[] = name.split(' ');
      const newNameArray: string[] = [];
      for (let i = 0; i < nameArray.length; i++) {
        if (newNameArray.length >= 2) break;

        if (nameArray[i]) {
          newNameArray.push(nameArray[i]);
        }
      }
      return newNameArray.join(' ');
    } else {
      return '';
    }
  }

  hidePopup(clientId: number) {
    this.zone.run(() => {
      this.clientId = clientId;
      this.GetCLientsByClientId();
      this.showCreateProspectPopup$.next(false);
    });
  }

  OpenPopup() {
    //this.showCreateProspectPopup$.next(true);
    this.createProspect.emit();
  }

  getTenant(client: any) {
    if (client && client.clt_home_club_tenant_id != 0)
      return this.allTenants.find((t: any) => t.id == client.clt_home_club_tenant_id);
    else if (client && client.clt_createdin_tenant_id != 0)
      return this.allTenants.find((t: any) => t.id == client.clt_createdin_tenant_id);
    else return null;
  }

  addClass(event:Event)
  {
    const clickedElement = event.target as HTMLElement;
    const classesToAdd = ['fa-spin', 'fa-spinner'];
    classesToAdd.forEach(className => {
      this.renderer.addClass(clickedElement.firstElementChild, className);
    });
  }

  removeClass(event:Event)
  {
    const clickedElement = event.target as HTMLElement;
    const classesToAdd = ['fa-spin', 'fa-spinner'];
    classesToAdd.forEach(className => {
      this.renderer.removeClass(clickedElement.firstElementChild, className);
    });
  }

  navigateToClientProfile(client:any ) {    
    this.openclientsidebar.emit({openclientsidebar:true,clientid:client.clt_id});
  }

}
